<template>
	<!-- eslint-disable-next-line vue/no-v-html -->
	<div :class="['cog-content', 'cog-html', 'cog-input', { 'cog-force-shown': forceShown}]" v-html="markup"></div>
</template>

<script>
	import { isSourceAdapter } from '@cognitoforms/vuemodel';
	import { escapeHtml } from 'src/util/helpers';
	import { getSiteUrl } from 'src/util/site-url';
	import { getPermalinkRetryUrl } from 'src/util/permalinks';

	export default {
		name: 'CContent',
		inject: ['$resource', 'log'],
		props: {
			content: { type: String, required: true },
			raw: { type: Boolean, default: false },
			forceShown: { type: Boolean, default: false }
		},
		computed: {
			entity() {
				for (let parent = this.$parent, parentLevel = 1; parent != null; parent = parent.$parent, parentLevel += 1)
					if (isSourceAdapter(parent.$source))
						return parent.$source.value;
				return null;
			},
			markup() {
				return this.formatText(this.raw || !this.entity ? this.content : this.entity.toString(this.content, value => this.wrapDataUriWithImg(value)));
			}
		},
		mounted() {
			this.setupImageErrorDetection();
		},
		updated() {
			this.setupImageErrorDetection();
		},
		methods: {
			formatText(value) {
				// Note: Equivalent of `Cognito.formatText` in v1 forms
				return value ? value.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\r/g, '<br/>') : value;
			},
			wrapDataUriWithImg(value) {
				if (!value || typeof value !== 'string')
					return value;
				else if (value.startsWith('data:image'))
					return `<img src="${escapeHtml(value)}" alt="${this.$resource('element-label-signature')}" />`;
				else
					return escapeHtml(value);
			},
			setupImageErrorDetection() {
				this.$nextTick(() => {
					const images = this.$el.querySelectorAll('img');
					const siteUrl = getSiteUrl();

					images.forEach(img => {
						// Only monitor uploaded images (those that start with the site URL)
						if (siteUrl && img.src.startsWith(siteUrl)) {
							this.attachImageErrorListener(img);
						}
					});
				});
			},
			attachImageErrorListener(img) {
				// Remove any existing listener for this image
				if (img._cognitoErrorHandler) {
					img.removeEventListener('error', img._cognitoErrorHandler);
					delete img._cognitoErrorHandler;
				}

				const onError = () => {
					const retryUrl = getPermalinkRetryUrl(img.src);
					if (retryUrl) {
						const originalUrl = img.src;
						// Attempt retry without redirect
						img.src = retryUrl;
						// Log trace when retrying
						if (this.log) {
							this.log.trace('Retrying image load with redirect=0', {
								imageUrl: originalUrl,
								imageLocation: 'Content'
							});
						}
						// Don't log error yet - give fallback a chance
						return;
					}

					this.logImageError('Content field uploaded image failed to load', {
						imageUrl: img.src
					});
				};

				// Store reference so we can remove it later
				img._cognitoErrorHandler = onError;
				img.addEventListener('error', onError);
			},
			logImageError(message, properties) {
				if (this.log) {
					this.log.error(new Error(message), properties);
				}
			}
		}
	};
</script>

<style lang="scss">
#{$specificity-base} {

	.cog-content pre {
		white-space: pre-wrap;
	}
}
</style>